import cn from 'classnames'
import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet-async'

import * as s from './Banner/LicenseExpiration/LicenseExpiration.module.scss'

const { contactSales } = window.PLATFORM

export const useContactSales = ({ email, name }: { email: string; name: string }) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [iframeExpanded, setIframeExpanded] = useState(false)
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const [firstName, ...lastNameParts] = name.split(' ')
  const open = () => setIsModalVisible(true)

  useEffect(() => {
    if (!isModalVisible) {
      setIframeExpanded(false)
      return
    }

    const handleBlur = () => {
      setTimeout(() => {
        if (document.activeElement === iframeRef.current) {
          setIframeExpanded(true)
        }
      }, 0)
    }

    window.addEventListener('blur', handleBlur)
    return () => window.removeEventListener('blur', handleBlur)
  }, [isModalVisible])

  const dataSrc = (() => {
    if (contactSales.type === 'none') {
      return ''
    }
    const base = new URL(contactSales.url)
    base.searchParams.set('email', email)
    base.searchParams.set('firstName', firstName)
    base.searchParams.set('lastName', lastNameParts.join(' '))
    return base.toString()
  })()

  const mount = isModalVisible ? (
    <div className={s.contactSales}>
      <div className={s.overlay} onClick={() => setIsModalVisible(false)} />
      {contactSales.type === 'planerka' && (
        <div className={s.contentWrapper}>
          <iframe
            className={cn(s.iframe, iframeExpanded && s.iframeExpanded)}
            ref={iframeRef}
            src={dataSrc}
            title='Contact Sales'
          />
        </div>
      )}
      {contactSales.type === 'hubspot' && (
        <>
          <div className={cn('meetings-iframe-container', s.content)} data-src={dataSrc} />
          <Helmet>
            <script
              src='https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
              type='text/javascript'
            />
          </Helmet>
        </>
      )}
    </div>
  ) : null
  return {
    mount,
    open,
  }
}
